export default {
  methods: {
    getNestedFormClass (index) {
      return `nested-form-item nested-form-item--${index % 2 === 0 ? 'even' : 'odd'}`
    },
  },
}
